<!-- Select Project -->
<label>Project</label>
<div class="dropdown">
  <select class="dropdown__select" [(ngModel)]="selectedProjectKey" (change)="onSelectedProjectChanged()">
    <option class="dropdown__item" *ngFor="let projectKey of projectKeys" [value]="projectKey">
      {{projectKey}}
    </option>
  </select>
  <div class="dropdown__icon">
    <i class="material-icons">keyboard_arrow_down</i>
    </div>
</div>
